'use client'

import { MouseEvent } from 'react'
import { useIntl } from 'react-intl'

import { formatCurrencyAmount } from '@marketplace-web/domain/currency-data'
import { ItemBox } from '@marketplace-web/domain/item-box'

import { BumpableItemModel } from '@marketplace-web/domain/vas-data'

type Props = {
  item: BumpableItemModel
  renderFooter?: JSX.Element | null
  testId?: string
  onClick?: (event: MouseEvent) => void
}

const BumpableItemBox = ({ item, onClick, renderFooter, testId }: Props) => {
  const { locale } = useIntl()

  const { id, price, thumbnailUrl, dominantColor, itemBox } = item
  const currentPrice = formatCurrencyAmount(price, locale)
  const itemTestId = testId || `bumpable-item-id-${id}`

  return (
    <ItemBox
      price={currentPrice}
      image={thumbnailUrl}
      imageColor={dominantColor}
      onClick={onClick}
      renderFooter={renderFooter}
      testId={itemTestId}
      itemBox={itemBox}
    />
  )
}

export default BumpableItemBox
